import React from "react";
import { Outlet } from "react-router-dom";

import { Box } from "@mui/material";
import { AdminSideNav } from "@src/components/Navigation/AdminSideNav/AdminSideNav";
import { IgPageContent } from "@src/utils/IgPageContent";

import { AlertProvider } from "./AlertProvider";

export const AdminPageProvider = () => {
  return (
    <Box
      id={"standard-page-provider-box"}
      sx={{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        // backgroundColor: "#F5F5F5",
        maxWidth: "1600px",
        height: "100dvh",
      }}
    >
      <AdminSideNav />
      <IgPageContent>
        <AlertProvider />
        <Outlet />
      </IgPageContent>
    </Box>
  );
};
